export default __webpack_public_path__ + "static/media/factura1.92241ec5.pdf";